import React, { useState, useEffect } from 'react';

const RoyaltyDistribution = ({ nextDistribution }) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Update timer every second
  useEffect(() => {
    const updateTimer = () => {
      const now = Math.floor(Date.now() / 1000);
      const remaining = nextDistribution - now;
      
      if (remaining <= 0) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      
      setTimeLeft({ hours, minutes, seconds });
    };
    
    // Initial update
    updateTimer();
    
    // Set interval for updates
    const interval = setInterval(updateTimer, 1000);
    
    // Clean up interval
    return () => clearInterval(interval);
  }, [nextDistribution]);

  // Format timer display
  const formatTime = () => {
    if (nextDistribution === 0 || (timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0)) {
      return 'Distribution processing...';
    }
    
    return `${timeLeft.hours.toString().padStart(2, '0')}:${timeLeft.minutes.toString().padStart(2, '0')}:${timeLeft.seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="royalty-distribution">
      <h2>Distribution Schedule</h2>
      <p>The royalty pool is distributed every 24 hours to all qualified members equally.</p>
      <div className="next-distribution">
        <div className="distribution-label">Next Distribution</div>
        <div className="distribution-timer">{formatTime()}</div>
      </div>
    </div>
  );
};

export default RoyaltyDistribution;
